export default __webpack_public_path__ + "static/media/avatar.197bf127.jpg";